import { useEffect, useMemo } from "react";
import { Link } from "wouter";
import { Calendar, Users } from "lucide-react";
import { AppLayout } from "@/components/layout/AppLayout";
import { Badge, Card, SectionTitle } from "@/components/Card";
import { useDemoStore } from "@/store/useDemoStore";
import { useEffectiveInstructorId, useGroupsForInstructor, useSessionsByGroup } from "@/store/hooks";

export default function InstructorGroups() {
  const setRole = useDemoStore((s) => s.setRole);
  useEffect(() => setRole("instructor"), [setRole]);
  const instructorId = useEffectiveInstructorId();
  const groups = useGroupsForInstructor(instructorId);
  const sessionsByGroup = useSessionsByGroup();
  const today = new Date().toISOString().slice(0, 10);

  return (
    <AppLayout pageTitle="Mis grupos" breadcrumb={["Instructor", "Mis grupos"]}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(320px,1fr))", gap: 14 }}>
        {groups.map((g) => {
          const sess = sessionsByGroup[g.id] ?? [];
          const upcoming = sess.filter((s) => s.fecha >= today).length;
          return (
            <Card key={g.id} testId={`card-group-${g.id}`}>
              <SectionTitle action={<Badge tone={g.estado === "en-curso" ? "teal" : g.estado === "planeado" ? "navy" : "gray"}>{g.estado}</Badge>}>
                {g.nombre}
              </SectionTitle>
              <div style={{ display: "flex", flexDirection: "column", gap: 8, fontSize: 12, color: "var(--cc-gray-600)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <Users size={13} color="var(--cc-teal)" /> {g.candidatosIds.length} candidatos
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <Calendar size={13} color="var(--cc-teal)" /> {g.inicio} → {g.fin} · {upcoming} próximas sesiones
                </div>
                <div style={{ marginTop: 6 }}>
                  <Link href={`/instructor/grupos/${g.id}`} data-testid={`link-open-${g.id}`} style={{ color: "var(--cc-teal)", fontWeight: 600, fontSize: 12, textDecoration: "none" }}>
                    Gestionar grupo →
                  </Link>
                </div>
              </div>
            </Card>
          );
        })}
        {groups.length === 0 && <Card><div style={{ padding: 14, fontSize: 13, color: "var(--cc-gray-500)" }}>No hay grupos.</div></Card>}
      </div>
    </AppLayout>
  );
}
